export const MAX_SUBJ_LENGTH = 128;
export const odsOrigin = 'https://cjs.diagnostics.office.com';
